import { useTranslation } from 'react-i18next';
import { Spinner } from 'src/components/ui/spinner';
import { Typography } from 'src/components/ui/typography';
import { useSidebarRows } from 'src/layouts/SidebarV2/hooks';
import { TRANSLATION_CONSTANTS as T } from 'src/utils/translations';

import { VirtualRowList } from './VirtualRowList';

const HistoryFlyout = () => {
  const { t } = useTranslation();
  const sidebarRows = useSidebarRows({ include: 'history' });

  return (
    <div className="tw:flex tw:h-full tw:w-[240px] tw:flex-col tw:overflow-hidden tw:border-r tw:border-solid tw:border-border-secondary tw:bg-main tw:p-m">
      {sidebarRows.isFetching && sidebarRows?.rows.length === 0 ? (
        <div className="tw:flex tw:justify-center tw:py-s">
          <Spinner size="sm" showText={false} />
        </div>
      ) : sidebarRows?.rows.length === 0 ? (
        <Typography
          variant="b3"
          align="left"
          colorClass="tw:text-text-secondary"
          className="tw:px-s tw:py-2xs"
        >
          {t(T.noChatHistory)}
        </Typography>
      ) : (
        <VirtualRowList {...sidebarRows} />
      )}
    </div>
  );
};

export { HistoryFlyout };
